import Welcome from './Pages/Welcome';
import Exemplo from './Pages/Exemplo';
import Signup from './Pages/Signup/Signup';
import CaptureDocumentMobile from './components/CaptureDocumentMobile/CaptureDocumentMobile';
import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SelfieCapture from "./Pages/SelfieCapture";
import MobileHandler from "./Pages/MobileHandler";
import SuccessHandler from './Pages/SuccessHandler';
import { Box } from '@mui/material';
import './App.sass'
import bepass_white_logo from "./images/logoCompleto.png";
import { BASE } from './basedata/constants';
import DocumentHandler from './Pages/DocumentHandler';
import { signInAnonymously } from 'firebase/auth';
import { auth } from './basedata/firebase';
import Validating from './Pages/Validating';
import Loader from './components/Loader/Loader';
import { apiUser } from './basedata/apiCall';
import ErrorHandler from './Pages/ErrorHandler';
import { useTranslation } from 'react-i18next';
import DocumentReuse from './Pages/DocumentReuse';
import AppHeader from './components/AppHeader/AppHeader';
import OptInPage from './Pages/OptIn';
import ErrorOptin from './Pages/ErrorOptin';
import NotFound from './Pages/NotFound'
import { isMobile as isMobileDevice } from 'react-device-detect';
import FacialInstructionsPage from './Pages/FacialInstructionsPage';
import MobilePagination from './components/MobilePagination/MobilePagination';
import DocumentInstructionsPage from './Pages/DocumentInstructionsPage';
import Layout from './components/Layout/Layout'
import { StepProvider } from './context/StepContext'
import DocumentUploadPage from './Pages/DocumentUploadPage';
import { loadBaseFromApi } from './basedata/constants';



const App = () => {

  const [tempCredentials, setTempCredentials] = useState<any>('')
  const [loading, setLoading] = useState(true)
  const [bootstrapLoaded, setBootstrapLoaded] = useState(true)
  const [userFlow, setuserFlow] = useState(false)

  const getCredentials = async () => {

    try {
      const userCredential: any = await signInAnonymously(auth)

      sessionStorage.setItem('user-key', JSON.stringify({ user_key: userCredential?.user?.accessToken, tenant_id: BASE.company.tenant }))
      const sessionItem: any = window.sessionStorage.getItem('user-key')

      setTempCredentials(userCredential.user?.accessToken)
    } catch (e) {
      return false
    }
    return true
  }

  const getUserFlow = async (userToken: any) => {

    try {

      const _response = await apiUser.post(`/biometry/onboarding/user-jorney`, { flowId: userToken })

      if (_response.data.status === 'success') {
        sessionStorage.setItem('user_history', _response.data.message)
        sessionStorage.setItem('get_flow_index', 'true')
        sessionStorage.setItem('document_type', _response.data.document_type || 'cpf')

        setuserFlow(true)

        const _current_location = window.location.pathname
        if (_response.data.message === 'selfie') {
          if (isMobileDevice && !/instructions/.test(_current_location)) {
            window.location.href = 'instructions';
          } else if (!isMobileDevice && !/selfie/.test(_current_location)) {
            window.location.href = 'selfie';
          }
        } else if (isMobileDevice && _response.data.message === 'document_front') {
          if (!/instructions-document/.test(_current_location)) {
            window.location.href = 'instructions-document?verse=false';
          }
        } else if (isMobileDevice && _response.data.message === 'document_back') {
          if (!/instructions-document/.test(_current_location)) {
            window.location.href = 'instructions-document?verse=true';
          }
        } else if (_response.data.message === 'done') {
          if (!/success/.test(_current_location)) {
            window.location.href = 'success'
          }
        }
        // setLoading(false)
      } else {
        // setLoading(false)
      }

    } catch (e) {
      console.log('errror!', e)
      setTimeout(() => {
        // window.location.reload()
      }, 3000);
    }
    return true
  }

  useEffect(() => {


    (async () => {
      await loadBaseFromApi();

      setTimeout(() => {
        document.documentElement.style.setProperty('--primary', BASE.company.primaryColor);
        setLoading(false)
        setBootstrapLoaded(false)
      }, 1000);
    })();

    getCredentials();

  }, [])

  useEffect(() => {

    const _flow_index = sessionStorage.getItem('get_flow_index')
    console.log(_flow_index)
    if (!_flow_index) {

      const params = new URLSearchParams(window.location.search)

      let currentToken: any = params.get('token');
      let currentOrc: any = params.get('orc');

      if (!currentToken) {
        currentToken = sessionStorage.getItem('token')
        currentOrc = sessionStorage.getItem('orc')
        if (!currentToken) {
          return setLoading(false)
        }
      } else {
        sessionStorage.setItem('token', currentToken)
        sessionStorage.setItem('orc', currentOrc)
      }

      const _has_history = sessionStorage.getItem('user_history')

      if (_has_history) {
        sessionStorage.setItem('get_flow_index', 'true')
        const _current_location = window.location.pathname
        if (_has_history === 'selfie') {
          if (isMobileDevice && !/instructions/.test(_current_location)) {
            window.location.href = 'instructions';
          } else if (!isMobileDevice && !/selfie/.test(_current_location)) {
            window.location.href = 'selfie';
          }
        }
        else if (_has_history === 'document_front') {
          if (!/instructions-document/.test(_current_location)) {
            window.location.href = 'instructions-document?verse=false';
          }
        } else if (_has_history === 'document_back') {
          if (!/instructions-document/.test(_current_location)) {
            window.location.href = 'instructions-document?verse=true';
          }
        }
        else if (_has_history === 'done') {
          if (!/success/.test(_current_location)) {
            window.location.href = 'success'
          }
        }
        // setLoading(false)
      } else {
        getUserFlow(currentToken);
      }
    } else {
      return setLoading(false)
    }
  }, [userFlow])


  const { i18n } = useTranslation();

  useEffect(() => {
    const lingua: any = window.sessionStorage.getItem('language')
    i18n.changeLanguage(lingua);
  }, [])

  return (
    loading || bootstrapLoaded ? (
      <div className="loader">
        <div className="spinner">
        </div>
      </div>
    ) : (
      <StepProvider>
        <Box>
          <Router>
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route
                path="/"
                element={
                  <Layout>
                    <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
                    <Welcome />
                  </Layout>
                }
              />
              <Route path="/signup" element={
                <Layout>
                  <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
                  <Signup />
                </Layout>
              } />
              <Route path="/mobile-handler" element={
                <Layout>
                  <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
                  <MobileHandler />
                </Layout>
              } />
              <Route path="/instructions" element={
                <Layout>
                  <FacialInstructionsPage />
                </Layout>
              } />
              <Route path="/instructions-document" element={
                <Layout>
                  <DocumentInstructionsPage />
                </Layout>
              } />
              <Route path="/selfie" element={
                <Layout headerVariant="dark" noPadding noFooter>
                  <SelfieCapture />
                </Layout>
              } />
              <Route path="/document-handler" element={
                <Layout>
                  <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
                  <DocumentHandler />
                </Layout>
              } />
              <Route path="/mobile-document" element={
                <Layout headerVariant='primary' noPadding noFooter >
                  <CaptureDocumentMobile />
                </Layout>
              } />
              <Route path="/success" element={
                <Layout>
                  <SuccessHandler />
                </Layout>
              } />
              <Route path="/document-choose" element={
                <Layout>
                  <DocumentReuse />
                </Layout>
              } />
              <Route path="/document-upload" element={
                <Layout>
                  <DocumentUploadPage />
                </Layout>
              } />
              <Route path="/waiting" element={
                <Layout>
                  <ErrorHandler />
                </Layout>
              } />
              <Route path="/opt-in" element={
                <Layout>
                  <OptInPage />
                </Layout>
              } />
              <Route path="/opt-contact" element={
                <Layout>
                  <ErrorOptin />
                </Layout>
              } />
              <Route path="/validating" element={
                <Layout>
                  <Validating />
                </Layout>
              } />
              <Route path="/css-colors" element={<Exemplo />} />
            </Routes>
          </Router>
          <p className='app-version'>v5.5</p>
        </Box>
      </StepProvider>
    )
  );
};


export default App;